<div class="wrapper" (click)="onClick()" (mouseenter)="onOver()" (mouseleave)="onOut()">
    <div class="inner">
        <app-circle [radius]="20" [stroke]="1" color="#fff" [isloop]="false" [on]="!isRollover"></app-circle>
        <img [src]="image" alt="">
    </div>
</div>
